/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetInventoryByItemQueryResult } from '../../models/get-inventory-by-item-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiNurseryManagerInventoryGetInventoryPost$Params {
      body?: {
'ItemId'?: string;
'StoreId'?: string;
'PageNumber'?: number;
'PageSize'?: number;
'Filters'?: Array<FilteredQuery>;
'Sorts'?: Array<SortedQuery>;
'SearchTerm'?: string;
}
}

export function apiNurseryManagerInventoryGetInventoryPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryGetInventoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryByItemQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryGetInventoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryByItemQueryResult>;
    })
  );
}

apiNurseryManagerInventoryGetInventoryPost.PATH = '/api/NurseryManager/Inventory/GetInventory';
